import { render, staticRenderFns } from "./CargoVesselLocation.vue?vue&type=template&id=7821830c"
import script from "./CargoVesselLocation.vue?vue&type=script&lang=js"
export * from "./CargoVesselLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7821830c')) {
      api.createRecord('7821830c', component.options)
    } else {
      api.reload('7821830c', component.options)
    }
    module.hot.accept("./CargoVesselLocation.vue?vue&type=template&id=7821830c", function () {
      api.rerender('7821830c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/CargoVesselLocation.vue"
export default component.exports